import QRCode from 'qrcode';

export async function qrDataUrl(text) {
  return QRCode.toDataURL(text, { width: 220, margin: 1, color: { dark: '#000000', light: '#ffffff' } });
}
